import { render, staticRenderFns } from "./StockList.vue?vue&type=template&id=ade245d4&scoped=true"
import script from "./StockList.vue?vue&type=script&lang=js"
export * from "./StockList.vue?vue&type=script&lang=js"
import style0 from "./StockList.vue?vue&type=style&index=0&id=ade245d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade245d4",
  null
  
)

export default component.exports